import * as React from 'react';

export interface GridRetargetingDescriptionCellProps {
    text?: string;
}
export class GridRetargetingDescriptionCell extends React.PureComponent<
    GridRetargetingDescriptionCellProps
> {
    render() {
        const { text } = this.props;

        return <div title={text}>{text || '–'}</div>;
    }
}
